import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; // CDN版を使用
import { ScrollToPlugin } from "gsap/ScrollToPlugin"; // CDN版を使用
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

/* lenis
*************************************************** */
let lenis;

document.addEventListener('DOMContentLoaded', () => {
  // プラグイン登録は1回でOK
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // ページローディング
  pageLoading();

  // Lenis設定
  lenis = new Lenis();
  lenis.on('scroll', ScrollTrigger.update);
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
});

/* アコーディオンパネルが開閉する際のアニメーション
*************************************************** */
$(function(){
  $('.question_box').click(function(){
    let $question = $(this).find('.question').first();
    let $answer = $(this).find('.answer').first();

    if ($answer.is(':visible')) {
      $answer.slideUp(300, function() {
        $(this).css('display', 'none'); // 完全に閉じる
      });
      $question.removeClass("is_open"); // アイコン用のクラスを削除
    } else {
      $answer.css('display', 'flex').hide().slideDown(300); // flex を適用しつつスライド
      $question.addClass("is_open"); // アイコン用のクラスを追加
    }
  });
});

/* ハンバーガーメニューの開閉アニメーション
*************************************************** */
document.addEventListener('DOMContentLoaded', () => {
  const active = 'is-active';
  const trigger = document.querySelector('.btn-trigger');
  const navWrap = document.querySelector('.hd_nav_wrap');

  if (!trigger || !navWrap) {
    return;
  }

  const setMenuState = (isOpen) => {
    trigger.classList.toggle(active, isOpen);
    navWrap.classList.toggle(active, isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    navWrap.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('is-menu-open', isOpen);
  };

  trigger.addEventListener('click', () => {
    setMenuState(!trigger.classList.contains(active));
  });

  navWrap.addEventListener('click', (e) => {
    if (e.target.closest('.hd_nav_overlay') || e.target.closest('a')) {
      setMenuState(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 1025px)').matches) {
      setMenuState(false);
    }
  });
});

/* フェードインの動き
*************************************************** */
$(function () {
  const selector = '.js-fadein';
  gsap.utils.toArray(selector).forEach( (item, index) => {
    gsap.set(item, {
      autoAlpha: 0,
      y: 100,
    });
    // GSAP
    gsap.to(item, {
      autoAlpha: 1,
      y: 0,
      duration: 0.5, // アニメーションの時間
      scrollTrigger: {
        trigger: item,
        start: 'top 80%',
        // once: false,
        // markers: true,
      }
    });
  })
});

if (document.body.classList.contains('contact')) {
  topValidation(); 
}



/* 年月日 - 年・月に合わせた日時表示
*************************************************** */
$(document).on('change','#select-year,#select-month',function(){
  $('#select-day option').show();

  // ★ ここに「let 」を追加して、変数宣言を明示します
  let $selected_year = $('#select-year option:selected').val();
  let $selected_month = $('#select-month option:selected').val();

  // 2月 - 閏年は29日まで、それ以外は28日まで
  if ( $selected_month == 2 ) {
    $('#select-day option[value="31"]').hide();
    $('#select-day option[value="30"]').hide();
    $('#select-day option[value="29"]').hide();
    if( $selected_year && ( (Math.floor($selected_year%4 == 0)) && (Math.floor($selected_year%100 != 0) ) || ( Math.floor($selected_year%400 == 0) ) ) ){
      $('#select-day option[value="29"]').show();
    }
  }
  // その他 4,6,9,11月は30日まで
  else if ( $selected_month == 4 || $selected_month == 6 || $selected_month == 9 || $selected_month == 11 ) {
    $('#select-day option[value="31"]').hide();
  }
});




// すべての .recruitment_table を取得
const units = document.querySelectorAll('.recruitment_table');

units.forEach(unit => {
  // その unit の中に .recruitment_list があるか探す
  const hasList = unit.querySelector('.recruitment_list') !== null;

  // もし無ければ (.recruitment_list が null なら)、その unit を削除する
  if (!hasList) {
    unit.remove();
  }
});

/*-------------------------------------------------------------------------------
  Contact Form 7 拡張プラグイン対応：遷移・スクロール制御
--------------------------------------------------------------------------------*/

// 1. スクロール実行関数（Lenis / GSAP 両対応）
const executeScroll = (selector) => {
  const target = document.querySelector(selector);
  const headerHeight = document.querySelector('.header')?.offsetHeight || 0;

  if (target) {
    // 確実に Lenis が初期化されているか確認
    if (typeof lenis !== 'undefined' && lenis !== null) {
      lenis.scrollTo(target, {
        offset: -headerHeight,
        duration: 1.2,
        immediate: false
      });
    } else {
      // LenisがなければGSAPで実行
      gsap.to(window, {
        duration: 1,
        scrollTo: { y: selector, offsetY: headerHeight },
        ease: "power2.inOut"
      });
    }
  }
};

// 2. 遷移後のハッシュ判定（thanksページ読み込み時）
window.addEventListener('load', () => {
  // プラグインが自動で slug:contact_thanks へ飛ばす際、
  // URLにハッシュがつかない場合があるため、URL自体に contact_thanks が含まれるかも判定
  if (window.location.hash === '#scroll' || window.location.pathname.includes('contact_thanks')) {
    // ページの描画とLenisの初期化を待つため、少し長めに待機
    setTimeout(() => {
      executeScroll('#thanks-anchor');
    }, 400);
  }
});

// 3. 確認画面ボタンやバリデーションエラー時のスクロール
// プラグイン独自のイベント 'wpcf7confirm' (もしあれば) や 標準イベントに反応
document.addEventListener('wpcf7invalid', () => {
  setTimeout(() => executeScroll('.contact_form_unit'), 100);
}, false);

// Contact Form 7の送信が「サーバー側で完了」した瞬間をブラウザでキャッチ
document.addEventListener('wpcf7mailsent', function(event) {
    // 確認画面プラグインが迷子になってループする前に、強制的にサンクスページへ切り替える
    window.location.href = '/contact_thanks/';
}, false);